// 將後端 response 的 key 換成 前端命名的 key
const mappingToBackendKey = new Map()
mappingToBackendKey.set('isAddEmployee', 'addEmployee')
mappingToBackendKey.set('isEditEmployee', 'editEmployee')
mappingToBackendKey.set('isSealEmployee', 'sealEmployee')
mappingToBackendKey.set('isAddManager', 'addManager')
mappingToBackendKey.set('isEditManagerPassword', 'editManagerPassword')
mappingToBackendKey.set('isSealManager', 'sealManager')
mappingToBackendKey.set('isEditSigning', 'editSigning')

// 將前端命名的 key 換成後端接收的 key
const mappingToFrotendKey = new Map()
mappingToFrotendKey.set('addEmployee', 'isAddEmployee')
mappingToFrotendKey.set('editEmployee', 'isEditEmployee')
mappingToFrotendKey.set('sealEmployee', 'isSealEmployee')
mappingToFrotendKey.set('addManager', 'isAddManager')
mappingToFrotendKey.set('editManagerPassword', 'isEditManagerPassword')
mappingToFrotendKey.set('sealManager', 'isSealManager')
mappingToFrotendKey.set('editSigning', 'isEditSigning')

export { mappingToBackendKey, mappingToFrotendKey}


// WEBPACK FOOTER //
// ./src/mapping.js